module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "statistics_3_1"
  }, [_c('div', {
    staticClass: "ttBar"
  }, [_c('span', [_vm._v(_vm._s(_vm.prevMs.name) + " - " + _vm._s(_vm.nameTrans()))]), _vm._v(" "), _c('span', {
    staticClass: "dateSpan"
  }, [_vm._v("（" + _vm._s(_vm.dateTime) + "）")])]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_vm._m(0), _vm._v(" "), _c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.testData), function(term) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(term.tName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.pv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.uv))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.ip))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(term.pTime))])])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "tabArea"
  }, [_c('div', {
    staticClass: "tabTtl"
  }, [_c('span', {
    staticClass: "ttText"
  }, [_vm._v("流量分析图")]), _vm._v(" "), _c('div', {
    staticClass: "timeArea"
  }, [_c('span', [_vm._v("时间域：")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "size": "small",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.mapDatFor
    },
    model: {
      value: (_vm.timeVal),
      callback: function($$v) {
        _vm.timeVal = $$v
      },
      expression: "timeVal"
    }
  }, _vm._l((_vm.timeSelect), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value,
        "disabled": item.disabled
      }
    })
  }))], 1)]), _vm._v(" "), [_c('v-chart', {
    staticStyle: {
      "height": "360px",
      "width": "100%"
    },
    attrs: {
      "options": _vm.line
    }
  })]], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabTtl"
  }, [_c('span', {
    staticClass: "ttText"
  }, [_vm._v("流量分析表")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "tHead"
  }, [_c('td'), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("浏览次数（PV）")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("独立访客（UV）")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "210px"
    }
  }, [_vm._v("IP访问量")]), _vm._v(" "), _c('td', [_vm._v("播放时长")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-8f3c44ca"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/statistics/schoolInner/flows.vue
// module id = 1542
// module chunks = 1